import {TheCrypt} from "../../TheCrypt";
import {TimelineLite} from "gsap";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class FreeSpinNoWinPause implements FlowStatePresentation {
    name: string = "FreeSpinNoWinPause";

    shouldRun(): boolean {
        return !TheCrypt.model.gameData.totalSpinWinnings;
    }

    start(controller: FlowStateController): void {
        const tl:TimelineLite = new TimelineLite();
        tl.add(()=>controller.finish(), 1);
    }
}